module.exports = __webpack_public_path__ + "2020922:8e3d68e2a81bc56d01f1/img/info_image@1x.6f930c0.png";